import React, { useState, useEffect } from 'react';
import * as S from './SwitchStyle';

export function Switch({ name, filters, onChange, list, $line, disabled }) {
  const [selected, setSelected] = useState(filters.type);

  const handleChange = (e) => {
    setSelected(e.target.value);
    onChange(name, e.target.value);
  };

  const selectedIndex = list.findIndex((item) => item.val === selected);

  useEffect(() => {
    setSelected(filters.type)
  // }, filters.type)
}, [filters.type])

  return (
    <S.Container $count={list.length} $line={$line} $disabled={disabled}>
      <S.Slider $index={selectedIndex} $count={list.length} $line={$line} $disabled={disabled} />
      {list.map((item) => (
        <S.Label key={item.val} $active={selected === item.val} $line={$line} $disabled={disabled}>
          <input
            type="radio"
            name="type"
            value={item.val}
            checked={selected === item.val}
            onChange={handleChange}
            disabled={disabled}
          />
          {item.name}
        </S.Label>
      ))}
    </S.Container>
  );
}
